import { Controller } from "stimulus";

export default class extends Controller {
  enforceMax(e) {
    const max = parseFloat(e.target.getAttribute('max'))
    const value = e.target.value

    if (value && parseFloat(value) > max) {
      e.target.value = max
    }
  }
}
